var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowright = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F2F2",
  d: "M0 0h8v16H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#arrowright_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FCFCFC",
  d: "M-1304-682H616v980h-1920z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#323333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m1 15 6-7-6-7"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrowright_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-1304-682H616v980h-1920z"
})))));
export { SvgArrowright as ReactComponent };
export default __webpack_public_path__ + "7b8e51dc43263dcc758a086d6a794237.svg";